import store from './store'
import axios from 'axios'
import cookies from 'js-cookie'
let resend=''
export default{
  getCookie (name) {
    return cookies.get(name)
  },
  setCookie (name,value,time) {
    return cookies.set(name, value, { expires: time })
  },
  removeCookie (name) {
    return cookies.remove(name)
  },
  GetQueryString(name){
    let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    let r = window.location.search.substr(1).match(reg);//search,查询？后面的参数，并匹配正则
    if(r!=null){
      return unescape(r[2])
    }else{
      return null
    } 
  },
  delUrlParam(url, ref) {
    // 如果不包括此参数
    if (url.indexOf(ref) == -1){
      return url
    }else{
      let arr_url = url.split('?')
      let base = arr_url[0]
      let arr_param = arr_url[1].split('&')
      let index = -1
      for ( let i = 0; i < arr_param.length; i++) {
        let paired = arr_param[i].split('=')
          if (paired[0] == ref) {
              index = i
              break
          }
      }
      if (index == -1) {
          return url
      } else {
          arr_param.splice(index, 1)
          return base + "?" + arr_param.join('&')
      }
    }
  },
  verCodeBtn(name,btn){
    let that=this
    let count=60
    let  verCodeBtn=document.getElementById(btn) 
    verCodeBtn.innerHTML="60秒后获取"
    verCodeBtn.disabled=true
    verCodeBtn.style.pointerEvents="none";
    verCodeBtn.style.color="#c3c3c3"
    resend =setInterval(function(){  
      count--
      if (count > 0){
        verCodeBtn.innerHTML=count+"秒后获取"
        that.setCookie(name,count,(1/86400)*count)
      }else {  
        clearInterval(resend);
        verCodeBtn.innerHTML="获取验证码" 
        verCodeBtn.style.color="#00a7f1"
        verCodeBtn.disabled=false
        verCodeBtn.style.pointerEvents="auto";
      }  
    }, 1000);
  },
  preventRefresh(name,btn){//防止刷新cookie重置验证码
    let that=this
    if(that.getCookie(name)){
      let count=that.getCookie(name)
      let verCodeBtn=document.getElementById(btn)
      verCodeBtn.innerHTML=count+"秒后获取"
      verCodeBtn.style.color="#c3c3c3"
      resend =setInterval(function(){  
        count--
        if (count > 0){
          verCodeBtn.disabled=true
          verCodeBtn.style.pointerEvents="none";
          verCodeBtn.innerHTML=count+"秒后获取"
          that.setCookie(name,count,(1/86400)*count)
        }else {
          clearInterval(resend); 
          verCodeBtn.disabled=false
          verCodeBtn.style.pointerEvents="auto";
          verCodeBtn.innerHTML="获取验证码" 
          verCodeBtn.style.color="#00a7f1"
        }  
      }, 1000);
    }
  },
  removeSetInterval(){//关闭验证码定时器
    clearInterval(resend)
  },
  getSex(psidno){//获取性别
    let sexno,sex;
    if(psidno.length==18){
        sexno=psidno.substring(16,17);
    }else if(psidno.length==15){
        sexno=psidno.substring(14,15);
    }else{
        //alert("错误的身份证号码，请核对！");
        return false;
    }
    let tempid=sexno%2;
    if(tempid==0){
        sex='女';
    }else{
        sex='男';
    }
    return sex;
  },
  getAge(d){//获取年龄
    //获取年龄  
    let myDate = new Date();  
    let month = myDate.getMonth() + 1;  
    let day = myDate.getDate();  
    let age = myDate.getFullYear() - d.substring(6, 10) - 1;  
    if (d.substring(10, 12) < month || d.substring(10, 12) == month && d.substring(12, 14) <= day) {  
        age++;  
    }
    return age;
  },
  urlToObj(str){//url参数转对象
    let obj = {};
    let arr1 = str.split("?")
    let arr2 = arr1[1].split("&")
    for(let i=0 ; i < arr2.length; i++){
      let res = arr2[i].split("=")
      obj[res[0]] = decodeURI(res[1])
    }
    return obj
  },
  distance(lat1,lng1,lat2,lng2){
    let radLat1 = this.rad(lat1);
    let radLat2 = this.rad(lat2);
    let a = radLat1 - radLat2;
    let b = this.rad(lng1) - this.rad(lng2);
    let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378.137;
    // EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000;
    return s
  },
  rad(d){
    return d*Math.PI/180.0
  },
  checkPhone(phone){ //校验手机号
      if(!(/^1[3456789]\d{9}$/.test(phone))){ 
        return false
      }else{
        return true
      }
  },
  //身份证号合法性验证
  IdentityCodeValid(code) { 
    var city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
    var tip = "";
    var pass= true;
    //验证身份证格式（6个地区编码，8位出生日期，3位顺序号，1位校验位）
    if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)){
        tip = "身份证号格式错误";
        pass = false;
    }else if(!city[code.substr(0,2)]){
        tip = "地址编码错误";
        pass = false;
    }else{
        //18位身份证需要验证最后一位校验位
        if(code.length == 18){
            code = code.split('');
            //∑(ai×Wi)(mod 11)
            //加权因子
            var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
            //校验位
            var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++)
            {
                ai = code[i];
                wi = factor[i];
                sum += ai * wi;
            }
            var last = parity[sum % 11];
            if(parity[sum % 11] != code[17]){
                tip = "校验位错误";
                pass =false;
            }
        }
    }
    return pass
  },
  curentday(){ 
    let now = new Date();
    let year = now.getFullYear();       //年
    let month = now.getMonth() + 1<10?'0'+(now.getMonth() + 1):(now.getMonth() + 1);     //月
    let day = now.getDate()<10?'0'+now.getDate():now.getDate()            //日
    
    let hh = now.getHours()<10?'0'+now.getHours():now.getHours()            //时
    let mm = now.getMinutes()<10?'0'+now.getMinutes():now.getMinutes()          //分
    let ss = now.getSeconds()<10?'0'+now.getSeconds():now.getSeconds()           //秒
    
    return year+'-'+month+'-'+day+' '+hh+':'+mm+':'+ss; 
  },
  curentTime(){ 
    let now = new Date();
    let hh = now.getHours()<10?'0'+now.getHours():now.getHours()            //时
    let mm = now.getMinutes()<10?'0'+now.getMinutes():now.getMinutes()          //分
    let ss = now.getSeconds()<10?'0'+now.getSeconds():now.getSeconds()           //秒
    return hh+':'+mm+':'+ss; 
  },
  iosScroll(){
    setTimeout(function() {
      let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
      window.scrollTo(0, Math.max(scrollHeight - 1, 0));
    }, 100);
  },
  getClassName(obj,sName){ //-->sName是class名字
    if(document.getElementsByClassName) {
      return obj.getElementsByClassName(sName);
    }else{      
      var aTmp = obj.getElementsByTagName('*');
      var aRes=[];
      var arr =[];
      for(var i=0;i<aTmp.length;i++){  
        arr = aTmp[i].className.split(' ');
        for (var j=0;j<arr.length;j++) {
          if(arr[j] == sName){
            aRes.push(aTmp[i]);
          }
        }
      }
      return aRes;
    }
  },
  getOnline() {
    if (sessionStorage.getItem('sessionId')) {
      var params = new URLSearchParams();
      params.append("sessionId", sessionStorage.getItem('sessionId'));
      this.$ajax
        .post("getSessionIdIsExist", params)
        .then(response => {
          if (response.result) {
            this.docName = response.user.name;
            // console.log('--------------------get-online---------------------', response.user.username)
          }
        })
        .catch(error => {});
    }
  },
  writeAuthCode(options){
    let canvas = document.getElementById(options.canvasId);
    canvas.width=options.width||300
    canvas.height=options.height||150
    let ctx = canvas.getContext('2d');/**创建一个canvas对象*/
    ctx.textBaseline = "middle";
    ctx.fillStyle = randomBgColor(180, 255);/**这个范围的颜色作背景看起来清晰一些*/
    ctx.fillRect(0, 0, options.width, options.height);
    for (let i = 0; i < options.txt.length; i++) {
      let txt = options.txt.charAt(i);/**让每个字不一样*/
      ctx.font = '20px SimHei';
      ctx.fillStyle = randomColor(50, 160); /**随机生成字体颜色*/
      ctx.shadowOffsetY = randomNum(-3, 3);
      ctx.shadowBlur = randomNum(-3, 3);
      ctx.shadowColor = "rgba(0, 0, 0, 0.3)";
      let x = options.width / (options.txt.length+1) * (i+1);
      let y = options.height / 2;
      let deg = randomNum(-30, 30);
      /**设置旋转角度和坐标原点*/
      ctx.translate(x, y);
      ctx.rotate(deg * Math.PI / 180);
      ctx.fillText(txt, 0, 0);
      /**恢复旋转角度和坐标原点*/
      ctx.rotate(-deg * Math.PI / 180);
      ctx.translate(-x, -y);
    }
    /**1~4条随机干扰线随机出现*/
    // for (let i = 0; i < randomNum(1,4); i++) {
    //   ctx.strokeStyle = randomColor(40, 180);
    //   ctx.beginPath();
    //   ctx.moveTo(randomNum(0, options.width), randomNum(0, options.height));
    //   ctx.lineTo(randomNum(0, options.width), randomNum(0, options.height));
    //   ctx.stroke();
    // }
    /**绘制干扰点*/
    // for (let i = 0; i < options.width / 6; i++) {
    //   ctx.fillStyle = randomColor(0, 255);
    //   ctx.beginPath();
    //   ctx.arc(randomNum(0, options.width), randomNum(0, options.height), 1, 0, 2 * Math.PI);
    //   ctx.fill();
    // }
    /**随机数字**/
    function randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    }
    /**随机颜色**/
    function randomColor(min, max) {
      let r = randomNum(min, max);
      let g = randomNum(min, max);
      let b = randomNum(min, max);
      return "rgb(" + r + "," + g + "," + b + ")";
    }
    function randomBgColor(min, max) {
      let r = randomNum(min, max);
      let g = randomNum(min, max);
      let b = randomNum(min, max);
      return 'rgb(234, 230, 234)'
      //return "rgb(" + r + "," + g + "," + b + ")";
    }
  }
} 